
import Vue, { PropType } from "vue";
import { Box, BoxStatus, BoxStyle, Gateway } from "@/models";
import BaseDropDown, { OptionItem } from "@/components/BaseDropDown.vue";
import SignalStrength from "@/components/v/SignalStrength.vue";

export type DataType = {
  options: OptionItem[];
  showing: boolean;
};

export default Vue.extend({
  name: "ToiletBoxListItem",

  components: {
    BaseDropDown,
    SignalStrength,
  },

  props: {
    box: Object as PropType<Box>,
    gateway: Object as PropType<Gateway>,
  },

  computed: {
    isAdmin(): boolean {
      return this.$auth.role === "admin";
    },
    boxStyleText(): string {
      switch (this.box?.boxStyle) {
        case BoxStyle.JAPANESE:
          return "和式";
        case BoxStyle.WESTERN:
          return "洋式";
        default:
          return "不明";
      }
    },

    statusText(): string {
      switch (this.box?.status) {
        case BoxStatus.RUNNING:
          return "稼動";
        case BoxStatus.IN_MAINTENANCE:
          return "メンテ中";
        case BoxStatus.IN_PREPARING:
          return "準備中";
        default:
          return "不明";
      }
    },

    statusClassText(): string {
      switch (this.box?.status) {
        case BoxStatus.RUNNING:
          return "";
        case BoxStatus.IN_MAINTENANCE:
          return "red";
        case BoxStatus.IN_PREPARING:
          return "red";
        default:
          return "";
      }
    },

    facilitiesText(): string {
      return String(this.box?.options?.length || 0);
    },

    editMenuClassText(): string {
      return this.showing ? "active" : "";
    },
    isGatewayStatusActive(): boolean {
      return this.gateway?.details?.status === "RUNNING";
    },
  },
  methods: {
    batteryText(battery: number | undefined): string {
      if (!battery || !this.isGatewayStatusActive) {
        return "";
      }
      if (battery < 20) {
        return "Low";
      }
      if (battery < 40) {
        return "Low";
      }
      if (battery < 75) {
        return "Mid";
      }
      return "High";
    },
    batteryTextClass(battery: number | undefined): string {
      if (!battery || !this.isGatewayStatusActive) {
        return "";
      }
      if (battery < 20) {
        return "battery-red";
      }
      if (battery < 40) {
        return "battery-orange";
      }
      return "battery-grey";
    },
    displayColor(vacancyStatus: { text: string; color: string | undefined } | undefined) {
      if (vacancyStatus === undefined || vacancyStatus.color === undefined) {
        return "#616161";
      } else {
        return vacancyStatus.color;
      }
    },
    displayVacancy(vacancyStatus: { text: string; color: string } | undefined) {
      if (vacancyStatus === undefined || !this.isGatewayStatusActive) {
        return "";
      } else {
        return vacancyStatus.text;
      }
    },
  },

  data(): DataType {
    return {
      options: [
        {
          label: "個室情報 編集",
          classes: [],
          disabled: false,
          clickAction: () => {
            this.$router.push({
              name: "company-toilet-box-detail",
              params: {
                toiletId: this.$router.currentRoute.params.toiletId,
                boxId: this.box.id as string,
              },
            });
          },
        },
        {
          label: "個室情報 削除",
          classes: ["red"],
          disabled: false,
          clickAction: () => {
            this.$router.push({
              name: "company-toilet-box-delete",
              params: {
                toiletId: this.$router.currentRoute.params.toiletId,
                boxId: this.box.id as string,
              },
            });
          },
        },
      ],
      showing: false,
    };
  },
});
